import { render, staticRenderFns } from "./SubmissionComplete.vue?vue&type=template&id=e83df1dc&scoped=true&"
import script from "./SubmissionComplete.vue?vue&type=script&lang=js&"
export * from "./SubmissionComplete.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionComplete.vue?vue&type=style&index=0&id=e83df1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83df1dc",
  null
  
)

export default component.exports